import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

// Llamada al server de Hugo
class CuadroDeMando {
  static getCuadroDeMando () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_cereal_total`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  static getCamionesEnTransito () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cpa_presunta`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  }

  // consulta a vista materializada
  static getCantidadTotalPorCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_cereal_fecha_cantidad_total_listado`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getTotalizadorCuadroDeMando () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_totalizador`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data.filas
    })
  };

  getProductividadAltaComCuadroDeMando () {
    const orden = '{"orden": ["usuario_alta_completa"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_altacom?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadIngresoCuadroDeMando () {
    const orden = '{"orden": ["usuario_ingreso"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_ingreso?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadCaladoCuadroDeMando () {
    const orden = '{"orden": ["puesto_de_calado"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_calado?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadBrutoCuadroDeMando () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_bruto`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadDestareCuadroDeMando () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_destare`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadVolcadoraCuadroDeMando () {
    const orden = '{"orden": ["volcadora_camiones"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_volcadora?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getCuposStopQCuadroDeMando () {
    const orden = '{"orden": ["fecha_cupo_custom", "cereal"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cpa_presunta_totalizadora?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getEstadisticaCuposCerealCuadroDeMando () {
    const orden = '{"orden": ["cereal", "fecha_cupo"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_estadistica_de_cupos_cereal?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getMovimientoSilos () {
    console.log('obtener listado de silos y sus movimientos')
    const orden = '{"orden": ["nombre_corto"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_estado_de_los_silos?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pueden obtener los silos.')
      return data
    })
  };

  static getCamionesConRemito () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cdmd_remitos_total`)
    return promise.then((result) => {
      return result.data
    })
  }
}

export default CuadroDeMando
